import React, { useEffect, useState } from "react";
import { atom, useRecoilState } from "recoil";
import PageTitle from "../../components/DefaultStyles/PageTitle";
import LineBox from "../../components/DefaultStyles/LineBox";
import Table, { TableBody, TableBodyItem } from "../../components/Table/Table";
import { PartyInfoFilterContainer } from "../../components/pages/Party/PartyInfo/PartyInfoFilter";
import Flex from "../../components/DefaultStyles/Flex";
import Search from "../../components/Filters/Search";
import FilterIcon from "../../components/DefaultStyles/FilterIcon";
import DropDown, { OptionType } from "../../components/Filters/DropDown";
import ConfirmBtn from "../../components/Button/ConfirmBtn";
import LineBtn from "../../components/Button/LineBtn";
import SpaceBetween from "../../components/DefaultStyles/SpaceBetween";
import Pagination from "../../components/Table/Pagination";
import { TotalCount } from "../Users/UserInfo";
import { getThousandComma } from "../../ApiTS/ApiCommonTS";
import { useApi } from "../../hooks/useApi";
import Loader from "../../components/DefaultStyles/Loader";
import { useNavigate } from "react-router-dom";

interface IStamp {
  uid: number;
  nickname: string;
  name: string;
  total: number;
  advert: number;
  attend: number;
  createParty: number;
  joinParty: number;
  newjoin: number;
  invite: number;
}

export const preregLinkaiPageState = atom<number>({
  key: "preregLinkaiPageState",
  default: 0,
});

export default function Prereg_linkai() {
  const navigate = useNavigate();
  const [savedPage, setSavedPage] = useRecoilState<number>(preregLinkaiPageState);

  const [page, setPage] = useState(savedPage);

  useEffect(() => {
    setSavedPage(page);
  }, [page]);
  const [searchValue, setSearchValue] = useState<string | undefined>("");
  const [filter, setFilter] = useState({
    type: 0,
  });
  const [dropdown, setDropdown] = useState<OptionType>({
    value: "",
    label: "타입 선택",
  });

  const { response, loading } = useApi({
    method: "get",
    url:
      `stamp?page=${page}&size=10&eventid=10015` +
      (searchValue !== "" ? `&uid=${searchValue}` : "") +
      (filter?.type > 0 ? `&type=${filter?.type}` : ""),
  });

  const tableHead = [
    "UID_이름_닉네임",
    // "총 개수",
    // "출석",
    // "광고 동의",
    // "파티 생성",
    // "파티 가입",
    // "친구 초대",
    // "회원 가입",
  ];

  const stampOption = [
    { value: "1", label: "출석" },
    { value: "2", label: "광고 동의" },
    { value: "6", label: "파티 생성" },
    { value: "5", label: "파티 가입" },
    { value: "3", label: "회원 가입" },
    { value: "4", label: "친구 초대" },
  ];

  return (
    <>
      <PageTitle title="링크아이 사전예약" />

      <PartyInfoFilterContainer maxWidth={950}>
        <Search
          placeholder="UID 입력"
          setSearchValue={setSearchValue}
          pageResetEvent={() => setPage(0)}
          inputType={"number"}
        />

        {/* <Flex gapSize={10}>
          <FilterIcon />

          <DropDown
            optionList={stampOption}
            dropdownValue={dropdown}
            setDropDownValue={setDropdown}
          />

          <ConfirmBtn
            btnText="적용"
            btnColor="mint"
            btnHeight={38}
            btnClickEvent={() => {
              setPage(0);
              setFilter({
                type: +dropdown?.value!,
              });
            }}
            isDisabled={dropdown?.value === ""}
          />

          <LineBtn
            btnText="초기화"
            btnColor="mint"
            icon="refresh"
            btnHeight={38}
            disabled={dropdown?.value === ""}
            btnClickEvent={() => {
              setFilter({
                type: 0,
              });
              setDropdown({
                value: "",
                label: "타입 선택",
              });
            }}
          />
        </Flex> */}
      </PartyInfoFilterContainer>

      <LineBox>
        <Table tableHeadData={tableHead}>
          <>
            {response?.data?.items?.map((d: IStamp) => (
              <TableBody key={d.uid}>
                <TableBodyItem
                  clickable
                  onClick={() => {
                    setSavedPage(page);
                    navigate(`/users/info/${d?.uid}`);
                  }}
                >
                  {d?.uid}_{d?.name}_{d?.nickname}
                </TableBodyItem>
                {/* <TableBodyItem>{getThousandComma(d?.total)}개</TableBodyItem>
                <TableBodyItem>{getThousandComma(d?.attend)}개</TableBodyItem>
                <TableBodyItem>{getThousandComma(d?.advert)}개</TableBodyItem>
                <TableBodyItem>
                  {getThousandComma(d?.createParty)}개
                </TableBodyItem>
                <TableBodyItem>
                  {getThousandComma(d?.joinParty)}개
                </TableBodyItem>
                <TableBodyItem>{getThousandComma(d?.invite)}개</TableBodyItem>
                <TableBodyItem>{getThousandComma(d?.newjoin)}개</TableBodyItem> */}
              </TableBody>
            ))}
          </>
        </Table>

        <SpaceBetween>
          <Pagination
            totalPage={response?.status === 200 ? response.data.totalPage : 1}
            currentPage={page}
            pageClickEvent={(index) => setPage(index)}
          />

          <TotalCount>
            총{" "}
            {getThousandComma(
              response?.status === 200 ? +response?.data?.totalCount : 0
            )}
            개
          </TotalCount>
        </SpaceBetween>
      </LineBox>

      {loading && <Loader />}
    </>
  );
}
